import React from "react";
import useStyles from "../styles/styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import fastRides from "../assets/img/fast-rides-section.webp";
import { handleAppStoreClick } from "../common/appStoreUtils";

import magicStarsIcon from "../assets/img/mage_stars-b-fill.svg";
import buildingIcon from "../assets/img/tabler_building.svg";
import clockIcon from "../assets/img/wi_time-1.svg";

const FastRidesSection = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const settings = useSelector((state) => state.settingsdata.settings);

  return (
    <div
      className={`${classes.bookaRideSection} ${classes.reverseOnMobile} ${classes.spacings}`}
    >
      <div className={classes.bookRideTextContainer}>
        <p className={classes.fastRidesSubtitle}>{t("ride_with_haraka")}</p>
        <h2 className={classes.h2SectionContainer} style={{ maxWidth: "25ch" }}>
          {t("fastRides")}
        </h2>

        <p className={classes.p1SectionContainer}>
          {t("fastRidesDescription")}
        </p>

        <ul className={classes.fastRidesList}>
          <li>
            <img src={clockIcon} alt={t("be_on_time")} />
            <p>{t("be_on_time")}</p>
          </li>
          <li>
            <img src={buildingIcon} alt={t("arrive_safely")} />
            <p>{t("arrive_safely")}</p>
          </li>
          <li>
            <img src={magicStarsIcon} alt={t("comfort_and_class")} />
            <p>{t("comfort_and_class")}</p>
          </li>
        </ul>

        <button
          className={`${classes.buttonSectionContainer} ${classes.primaryBtn}`}
          onClick={handleAppStoreClick(settings, "/login?signup=true")}
        >
          {t(`downloadHaraka`)}
        </button>
      </div>

      <div className={classes.sectionImageContainer}>
        <img
          className={classes.sectionContainerImage}
          src={fastRides}
          alt="home"
        />
      </div>
    </div>
  );
};

export default FastRidesSection;
